module.exports = __webpack_public_path__ + "assets1672972624428/img/home-img.ff28be9e.jpg";